import { render, staticRenderFns } from "./ModalParametrosClienteActivaSub.vue?vue&type=template&id=1285b923"
import script from "./ModalParametrosClienteActivaSub.vue?vue&type=script&lang=js"
export * from "./ModalParametrosClienteActivaSub.vue?vue&type=script&lang=js"
import style0 from "./ModalParametrosClienteActivaSub.vue?vue&type=style&index=0&id=1285b923&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports